import { useState } from "react";
import { Link as LinkIcon, Copy, Check, WhatsappLogo, ChatText } from "@phosphor-icons/react";
import { toast } from "sonner";
import { buildFicheUrl } from "./callListHelpers";

// VAGUE 41 — per-prospect fiche link (with telepro ?ref= code) + share buttons.
function waPhone(phone) {
  const d = (phone || "").replace(/\D/g, "");
  if (/^0[67]\d{8}$/.test(d)) return `33${d.slice(1)}`;
  if (/^33[67]\d{8}$/.test(d)) return d;
  return "";
}

export default function FicheShareLinks({ biz, phone, teleproCode, compact = false }) {
  const [copied, setCopied] = useState(false);
  if (!biz?.slug) return null;
  const url = buildFicheUrl(biz.slug, teleproCode);
  const msg = `Bonjour, voici la fiche de ${biz.name} sur MonCommerce68 : ${url}\nCliquez sur « C'est mon entreprise » pour l'activer (14 jours gratuits, sans engagement).`;
  const wa = `https://wa.me/${waPhone(phone)}?text=${encodeURIComponent(msg)}`;
  const sms = `sms:${(phone || "").replace(/\s/g, "")}?&body=${encodeURIComponent(msg)}`;
  const btn = "inline-flex items-center gap-1 text-[11px] font-semibold border rounded-sm px-2 py-1 transition-colors";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Lien de la fiche copié");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copie impossible — sélectionne le lien à la main");
    }
  };

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${compact ? "" : "mt-1.5"}`} data-testid={`fiche-link-${biz.id}`}>
      <a href={url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-[11px] font-mono text-primary hover:underline truncate max-w-[220px]" data-testid={`fiche-link-open-${biz.id}`} title={url}>
        <LinkIcon size={11} weight="bold"/> Fiche du prospect
      </a>
      <button type="button" onClick={copy} className={`${btn} bg-card border-border hover:bg-muted`} data-testid={`fiche-link-copy-${biz.id}`}>
        {copied ? <Check size={11} weight="bold"/> : <Copy size={11} weight="bold"/>} {copied ? "Copié" : "Copier"}
      </button>
      <a href={wa} target="_blank" rel="noopener noreferrer" className={`${btn} bg-[#25D366]/10 text-[#128C7E] border-[#25D366]/40 hover:bg-[#25D366]/20`} data-testid={`fiche-link-whatsapp-${biz.id}`}>
        <WhatsappLogo size={11} weight="fill"/> WhatsApp
      </a>
      <a href={sms} className={`${btn} bg-card border-border hover:bg-muted`} data-testid={`fiche-link-sms-${biz.id}`}>
        <ChatText size={11} weight="bold"/> SMS
      </a>
    </div>
  );
}
